import rotowireLogo from '#src/assets/icons/rotowireLogo.webp';
import { unitMapping } from '#src/lib/style.ts';

export const RotowireSmallLogo = ({
  size,
}: {
  size: keyof typeof unitMapping;
}) => <img style={{ width: unitMapping[size] }} src={rotowireLogo} alt="" />;
